import React, { createRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PersonaVideo from '../components/PersonaVideo';
import ContentCardDisplay from '../components/ContentCardDisplay';
import {
  disconnect, sendEvent, setVideoDimensions,
} from '../store/sm/index';
import Header from '../components/Header';
import {
  disconnectPage, disconnectRoute,
} from '../config';
import TextInput from '../components/TextInput';

function DPChat({
  className,
}) {
  const {
    connected,
    loading,
    disconnected,
    micOn,
    error,
  } = useSelector(({ sm }) => ({ ...sm }));

  const dispatch = useDispatch();
  const history = useHistory();

  // Disable transcription by default
  const [showTranscript] = useState(false);

  if (disconnected === true) {
    if (disconnectPage) {
      history.push(disconnectRoute);
    } else history.push('/');
  } else if (error !== null) history.push('/loading?error=true');
  else if (connected !== true) history.push('/');

  const handleResize = () => {
    if (connected) {
      dispatch(setVideoDimensions({
        videoWidth: window.innerWidth,
        videoHeight: window.innerHeight,
      }));
    }
  };

  const [startedAt] = useState(Date.now());
  const cleanup = () => {
    if (Date.now() - startedAt < 1000) {
      console.warn('cleanup function invoked less than 1 second after component mounted, ignoring!');
    } else {
      console.log('cleanup function invoked!');
      window.removeEventListener('resize', handleResize);
      if (connected === true && loading === false) dispatch(disconnect());
    }
  };

  useEffect(() => {
    dispatch(sendEvent({ eventName: '', payload: {}, kind: 'init' }));
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => cleanup();
  }, []);

  window.onbeforeunload = () => {
    console.log('cleaning up');
    cleanup();
  };

  const ccDisplaRef = createRef();
  const [ccDisplayHeight, setCCDisplayHeight] = useState('auto');
  useEffect(() => {
    setCCDisplayHeight(ccDisplaRef.current.clientHeight);
  }, [ccDisplaRef]);

  return (
    <div className={className}>
      <div className="video-overlay">
        <div className="row">
          <Header />
        </div>
        {/* middle row */}
        <div
          className="row d-flex justify-content-end align-items-center flex-grow-1 ps-3 pe-3"
          style={{ overflow: 'hidden' }}
          ref={ccDisplaRef}
        >
          <div className="col col-md-5 d-flex align-items-end align-items-md-center" style={{ height: `${ccDisplayHeight}px` || 'auto' }}>
            <div>
              <ContentCardDisplay />
            </div>
          </div>
          {showTranscript === true || micOn === false ? (
            <div className="row justify-content-center">
              <div className="col-md-12 col-lg-6 p-3">
                <TextInput />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {connected ? <PersonaVideo /> : null}
    </div>
  );
}

DPChat.propTypes = {
  className: PropTypes.string.isRequired,
};

export default styled(DPChat)`
  height: 100vh;

  .video-overlay {
    overflow: hidden;  /* Prevent scrolling for the video overlay */
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .vertical-fit-container {
    flex: 0 1 auto;
    overflow-y: hidden;  /* Disable vertical scrolling */
    scrollbar-width: none; /* Firefox 64 */
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
